export default class TexsController {
	/* @ngInject */
	constructor(
		$scope,
		$state,
		$uibModal,
		registresService,
		PaginationService,
		dapService,
		notification,
		$translate,
		moment,
		ModalService,
		globalizationManagementService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.notification = notification;
		this.moment = moment;
		this.ModalService = ModalService;
		this.registresService = registresService;
		this.PaginationService = PaginationService;
		this.DapService = dapService;
		this.loaded = true;
		this.typeRegistre = 1; // 1 = texs entrant, 2 = texs sortant, 5 = dnd entrant, 6 = dnd sortant
		this.dateFormat = globalizationManagementService.getCurrentLanguage().dateFormat;
		this.declarationRndts = [];
		this.nomenclatures = [];
		this.nomenclaturesAllowed = [];
		this.societes = [];
		this.sites = [];
		this.clients = [];
		this.idClients = [];
		this.unregister = [];
		this.loading = false;
		this.lastTypeRegistre = this.typeRegistre;
		this.dapFiltering = 0;
		this.listLinkedDap = [];
		this.filtersOpen = true;
	}

	async $onInit() {
		await this.loadSocietes();
		await this.loadClients();
		this.unregister.push(
			this.$scope.$watch(
				() => this.idSociete,
				() => {
					if (this.idSociete && this.idSociete > 0) {
						this.declarationRndts = [];
						this.sites = [];
						this.idSite = null;
						this.loadSitesBySocieteId(this.idSociete);
					}
				},
				true
			)
		);

		await this.loadNomenclatures();
	}

	async getDapGeoVerification(bool) {
		var res = await this.registresService.verifyDapGeoLoc(
			this.idSociete,
			this.dateDebut,
			this.dateFin,
			this.idSite,
			this.nomenclatures.filter((x) => x.selected).map((x) => x.id),
			bool
		);
		if (!res || !res.data || res.data.length == 0) {
			this.notification.success(this.$translate.instant('REGISTRES.DAP_GEO_LOC.ALL_GPS_COMPLETE'));
			return;
		}

		this.$uibModal.open({
			animation: true,
			component: 'dapGeoLocFixCallback',
			size: 'lg',
			resolve: {
				result: () => res,
				getDapGeoVerification: () => (bool) =>
					this.registresService.verifyDapGeoLoc(
						this.idSociete,
						this.dateDebut,
						this.dateFin,
						this.idSite,
						this.nomenclatures.filter((x) => x.selected).map((x) => x.id),
						bool
					)
			}
		});
	}

	async $doCheck() {
		if (this.lastTypeRegistre != this.typeRegistre) {
			this.lastTypeRegistre = this.typeRegistre;
			this.declarationRndts = [];
		}
	}

	async loadNomenclatures() {
		try {
			const [n, na] = await Promise.all([
				this.registresService.getNomenclatures(),
				this.registresService.getNomenclaturesAutorisee(this.typeRegistre)
			]);
			this.nomenclatures = n?.data?.items ?? [];
			this.nomenclaturesAllowed = na?.data ?? [];

			const allowedCodes = new Set(this.nomenclaturesAllowed.map((nom) => nom.code));

			this.nomenclatures = this.nomenclatures.filter((x) => allowedCodes.has(x.code));
			this.nomenclatures.forEach((nom) => {
				nom.selected = allowedCodes.has(nom.code);
			});
		} catch (error) {
			console.error('Error loading nomenclatures:', error);
			this.nomenclatures = [];
			this.nomenclaturesAllowed = [];
		}
	}

	async nomenclaturesUpdate(data) {
		console.log(data);
	}

	async loadSocietes() {
		try {
			this.societes = await this.registresService.getSocietes();
			if (this.societes.length == 1) {
				this.idSociete = this.societes[0].id;
			}
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}
	async loadSitesBySocieteId(idSociete) {
		try {
			this.sites = await this.registresService.getSitesBySocieteId(idSociete);
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async loadClients() {
		try {
			this.clients = await this.registresService.getClients();
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async click() {
		let t = await this.registresService.getEntrants(1, '2024-01-01 00:00', '2025-04-30 00:00');
		console.log(t);
	}

	load(bool) {
		this.loading = bool;
	}

	printDeclarationRndts = async () => {
		if (this.dateDebut && this.dateFin && this.idSociete) {
			var res = null;
			try {
				if (this.typeRegistre == 1 || this.typeRegistre == 5) {
					res = await this.registresService.printEntrants(
						this.typeRegistre,
						this.idSociete,
						this.dateDebut,
						this.dateFin,
						this.idSite,
						this.nomenclatures.filter((x) => x.selected).map((x) => x.id),
						this.dapFiltering
					);
				} else if (this.typeRegistre == 2 || this.typeRegistre == 6) {
					res = await this.registresService.printSortants(
						this.typeRegistre,
						this.idSociete,
						this.dateDebut,
						this.dateFin,
						this.idSite,
						this.nomenclatures.filter((x) => x.selected).map((x) => x.id),
						this.dapFiltering
					);
				}

				if (res) {
					const data = res.data;
					let headers = res.headers;
					headers = headers();

					const contentType = headers['content-type'];
					let entrant = 'entrant';
					let typeTexs = 'texs';
					if (this.typeRegistre == 5 || this.typeRegistre == 6) {
						typeTexs = 'dnd';
					}
					if (this.typeRegistre == 2 || this.typeRegistre == 6) {
						entrant = 'sortant';
					}
					const linkElement = document.createElement('a');
					try {
						const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
						const url = window.URL.createObjectURL(blob);
						linkElement.setAttribute('href', url);
						linkElement.setAttribute('download', `export_${typeTexs}_${entrant}_${this.dateDebut}_${this.dateFin}.xlsx`);

						const clickEvent = new MouseEvent('click', {
							view: window,
							bubbles: true,
							cancelable: false
						});
						linkElement.dispatchEvent(clickEvent);
					} catch (ex) {
						console.error(ex);
					}
				}
			} catch (ex) {
				console.log(ex);
				this.notification.error(ex.data);
			}
		}
	};

	canValid() {
		if (this.dateDebut && this.dateFin && this.idSociete && this.idSite) {
			return true;
		} else {
			return false;
		}
	}

	loadDeclarationRndts = async () => {
		this.load(true);
		if (this.dateDebut && this.dateFin && this.idSociete && this.idSite) {
			this.declarationRndts = [];
			this.declarationRndtsWithMeta = {};
			var res = null;
			try {
				if (this.typeRegistre == 1 || this.typeRegistre == 5) {
					res = await this.registresService.getEntrants(
						this.idSociete,
						this.dateDebut,
						this.dateFin,
						this.idSite,
						this.nomenclatures.filter((x) => x.selected).map((x) => x.id),
						this.dapFiltering
					);
				} else if (this.typeRegistre == 2 || this.typeRegistre == 6) {
					res = await this.registresService.getSortants(
						this.idSociete,
						this.dateDebut,
						this.dateFin,
						this.idSite,
						this.nomenclatures.filter((x) => x.selected).map((x) => x.id),
						this.dapFiltering
					);
				}
				if (res) {
					this.declarationRndtsWithMeta = res;
					this.declarationRndts = res.data.content;

					const blError = this.declarationRndts.filter((bl) => bl.transportError == true);
					if (blError && blError.length > 0) {
						let msgInfo = '<ul>' + this.$translate.instant('REGISTRES.BL_ERROR.TRANSPORT');
						blError.forEach((bl) => {
							msgInfo =
								msgInfo +
								'<li>' +
								'<a href="gestion.html#!/tickets/' +
								bl.idTicket +
								'" target="_blank">' +
								bl.numeroTicket +
								'&nbsp;' +
								'<span class="glyphicon glyphicon-share"></span></a>' +
								'</li>';
						});
						msgInfo = msgInfo + '</ul>';
						this.ModalService.info({
							modalTitle: this.$translate.instant('REGISTRES.BL_ERROR.TITLE'),
							modalMsg: msgInfo
						});
					}
				} else {
					this.notification.warning('Aucun résultat');
				}
			} catch (ex) {
				console.log(ex);
				this.notification.error(ex.data);
			}
		}

		this.load(false);
	};
}
